{
  "art-balloons": {
    "352": [
      352,
      466
    ],
    "528": [
      528,
      698
    ],
    "704": [
      704,
      931
    ]
  },
  "art-downtown-fv": {
    "480": [
      480,
      362
    ],
    "720": [
      720,
      542
    ],
    "960": [
      960,
      723
    ]
  },
  "art-england": {
    "480": [
      480,
      377
    ],
    "720": [
      720,
      565
    ],
    "960": [
      960,
      753
    ]
  },
  "art-golden-field": {
    "480": [
      480,
      350
    ],
    "720": [
      720,
      525
    ],
    "960": [
      960,
      700
    ]
  },
  "art-jordan-lake": {
    "1200": [
      1200,
      1548
    ],
    "600": [
      600,
      774
    ],
    "900": [
      900,
      1161
    ]
  },
  "art-landscape-pastel": {
    "1136": [
      1136,
      1440
    ],
    "568": [
      568,
      720
    ],
    "852": [
      852,
      1080
    ]
  },
  "art-lemons": {
    "375": [
      375,
      281
    ],
    "562": [
      562,
      421
    ],
    "750": [
      750,
      562
    ]
  },
  "art-mountain-color": {
    "1200": [
      1200,
      924
    ],
    "600": [
      600,
      462
    ],
    "900": [
      900,
      693
    ]
  },
  "art-pastel-portrait": {
    "1200": [
      1200,
      1500
    ],
    "600": [
      600,
      750
    ],
    "900": [
      900,
      1125
    ]
  },
  "art-pink-flowers": {
    "480": [
      480,
      480
    ],
    "720": [
      720,
      720
    ],
    "960": [
      960,
      960
    ]
  },
  "art-river-trees": {
    "424": [
      424,
      315
    ],
    "636": [
      636,
      473
    ],
    "848": [
      848,
      630
    ]
  },
  "art-sunflowers": {
    "1200": [
      1200,
      1593
    ],
    "600": [
      600,
      797
    ],
    "900": [
      900,
      1195
    ]
  },
  "art-woods-path": {
    "480": [
      480,
      480
    ],
    "720": [
      720,
      720
    ],
    "960": [
      960,
      960
    ]
  },
  "class-palette": {
    "1000": [
      1000,
      750
    ],
    "500": [
      500,
      375
    ],
    "750": [
      750,
      563
    ]
  },
  "class-stilllife": {
    "480": [
      480,
      360
    ],
    "720": [
      720,
      540
    ],
    "960": [
      960,
      720
    ]
  },
  "class-students": {
    "375": [
      375,
      667
    ],
    "562": [
      562,
      1000
    ],
    "750": [
      750,
      1334
    ]
  },
  "frame-selection": {
    "1000": [
      1000,
      599
    ],
    "500": [
      500,
      300
    ],
    "750": [
      750,
      450
    ]
  },
  "framed-book": {
    "1000": [
      1000,
      1333
    ],
    "500": [
      500,
      667
    ],
    "750": [
      750,
      1000
    ]
  },
  "framed-coins": {
    "360": [
      360,
      480
    ],
    "540": [
      540,
      720
    ],
    "720": [
      720,
      960
    ]
  },
  "framed-family-photos": {
    "479": [
      479,
      276
    ],
    "719": [
      719,
      415
    ],
    "959": [
      959,
      553
    ]
  },
  "framed-flag": {
    "376": [
      376,
      480
    ],
    "564": [
      564,
      720
    ],
    "752": [
      752,
      960
    ]
  },
  "framed-guitar": {
    "450": [
      450,
      600
    ],
    "675": [
      675,
      900
    ],
    "900": [
      900,
      1200
    ]
  },
  "framed-jersey": {
    "375": [
      375,
      281
    ],
    "562": [
      562,
      421
    ],
    "750": [
      750,
      562
    ]
  },
  "framed-jersey-medal": {
    "450": [
      450,
      338
    ],
    "675": [
      675,
      506
    ],
    "900": [
      900,
      675
    ]
  },
  "framed-mask": {
    "1000": [
      1000,
      1333
    ],
    "500": [
      500,
      667
    ],
    "750": [
      750,
      1000
    ]
  },
  "framed-medals": {
    "361": [
      361,
      480
    ],
    "541": [
      541,
      719
    ],
    "722": [
      722,
      960
    ]
  },
  "framed-varsity": {
    "360": [
      360,
      480
    ],
    "540": [
      540,
      720
    ],
    "720": [
      720,
      960
    ]
  },
  "happy-customer": {
    "360": [
      360,
      480
    ],
    "540": [
      540,
      720
    ],
    "720": [
      720,
      960
    ]
  },
  "hero-frames": {
    "450": [
      450,
      270
    ],
    "675": [
      675,
      405
    ],
    "900": [
      900,
      539
    ]
  },
  "logo": {
    "128": [
      128,
      128
    ]
  },
  "mat-designs": {
    "360": [
      360,
      640
    ],
    "540": [
      540,
      960
    ],
    "720": [
      720,
      1280
    ]
  },
  "photo-restoration": {
    "359": [
      359,
      639
    ],
    "539": [
      539,
      960
    ],
    "719": [
      719,
      1280
    ]
  },
  "shadow-box": {
    "281": [
      281,
      375
    ],
    "421": [
      421,
      562
    ],
    "562": [
      562,
      750
    ]
  },
  "shirley-photo": {
    "450": [
      450,
      515
    ],
    "700": [
      700,
      802
    ],
    "900": [
      900,
      1031
    ]
  },
  "shop-exterior": {
    "1000": [
      1000,
      664
    ],
    "500": [
      500,
      332
    ],
    "750": [
      750,
      498
    ]
  },
  "shop-street": {
    "1000": [
      1000,
      394
    ],
    "500": [
      500,
      197
    ],
    "750": [
      750,
      295
    ]
  },
  "story-ballentine": {
    "302": [
      302,
      226
    ],
    "453": [
      453,
      339
    ],
    "604": [
      604,
      452
    ]
  },
  "story-old-sign": {
    "128": [
      128,
      101
    ],
    "192": [
      192,
      151
    ],
    "256": [
      256,
      201
    ]
  },
  "studio-bench": {
    "320": [
      320,
      240
    ],
    "480": [
      480,
      360
    ],
    "640": [
      640,
      480
    ]
  },
  "studio-design-counter": {
    "320": [
      320,
      240
    ],
    "480": [
      480,
      360
    ],
    "640": [
      640,
      480
    ]
  },
  "studio-frame-corners": {
    "320": [
      320,
      240
    ],
    "480": [
      480,
      360
    ],
    "640": [
      640,
      480
    ]
  },
  "studio-frame-wall": {
    "320": [
      320,
      240
    ],
    "480": [
      480,
      360
    ],
    "640": [
      640,
      480
    ]
  },
  "studio-matboards": {
    "240": [
      240,
      320
    ],
    "360": [
      360,
      480
    ],
    "480": [
      480,
      640
    ]
  },
  "studio-worktable": {
    "320": [
      320,
      240
    ],
    "480": [
      480,
      360
    ],
    "640": [
      640,
      480
    ]
  }
}